import { render, staticRenderFns } from "./vip-upgrade-info-modal.vue?vue&type=template&id=5416dfa2&"
import script from "./vip-upgrade-info-modal.vue?vue&type=script&lang=js&"
export * from "./vip-upgrade-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports